import { catchError, map, Observable, of, tap } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { SubType } from '../../../../models/subtype/SubType.model';
import { SubTypeDTO } from '../../../../dto/subtype/subtype.dto';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { FunctionRegistryService } from '../../../function-registry/function-registry.service';
import { environment } from '../../../../environment/environment';

export function subtypes(componentDataSourceService: ComponentDataSourceService, functionRegistryService: FunctionRegistryService) {
  return {
    name: 'Subtypes',
    description: 'Lists all subtypes',
    execute: (params?: LoadDataParams) => {
      
      return componentDataSourceService.http.get<any>(
        `${environment.apiUrl}/events/subtypes`,
        params?.queryParams ? { params: params.queryParams } : {}
      ).pipe(
        catchError(error => {
          console.error('Error fetching subtypes:', error);
          return of({ items: [], totalCount: 0 });
        }),
        map(result => {
          if (result && result.items) {
            try {
              const subtypes = result.items.map((subtype: any) => {
                const subtypeDTO: SubTypeDTO = {
                  subtype_id: subtype.subtype_id,
                  base_subtype_id: subtype.base_subtype_id,
                  name: subtype.name,
                  descriptions: subtype.descriptions,
                  visibility: subtype.visibility,
                  maintenance_minutes: subtype.maintenance_minutes || 0,
                  versions: subtype.versions || []
                };
                
                const convertedSubType = SubType.fromDTO(subtypeDTO);
                
                // For display purposes, get latest version info if available
                let displayStartDate = null;
                let displayEndDate = null;
                let latestVersionDescription = '';
                
                if (convertedSubType.versions && convertedSubType.versions.length > 0) {
                  // Sort versions by valid_from date (descending) to get the latest one
                  const sortedVersions = [...convertedSubType.versions].sort((a, b) => 
                    new Date(b.valid_from).getTime() - new Date(a.valid_from).getTime()
                  );
                  
                  const latestVersion = sortedVersions[0];
                  displayStartDate = latestVersion.valid_from;
                  displayEndDate = latestVersion.valid_to;
                  
                  // Get description from the latest version if available
                  if (latestVersion.descriptions && latestVersion.descriptions['da']) {
                    latestVersionDescription = latestVersion.descriptions['da'].translation_text || '';
                  }
                }
                
                const transformedSubtype = {
                  ...convertedSubType,
                  descriptions: convertedSubType.descriptions?.['da']?.translation_text || '',
                  latestVersionDescription,
                  displayStartDate,
                  displayEndDate,
                  versionCount: convertedSubType.versions?.length || 0
                };
                return transformedSubtype;
              });

              // Return data in the same format as modules.ts
              return {
                items: subtypes,
                totalCount: result.totalCount || subtypes.length,
                pageSize: result.pageSize || 10,
                pageIndex: result.pageIndex || 0
              };
            } catch (error) {
              console.error('Error converting DTO to SubType:', error);
              return { items: [], totalCount: 0, pageSize: 10, pageIndex: 0 };
            }
          } else {
            throw new Error('No custom subtypes found');
          }
        })
      );
    },
    settings: {
      columns: [
        { key: 'name', header: 'Navn', type: 'text' },
        { key: 'displayStartDate', header: 'Seneste version fra', type: 'date' },
        { key: 'displayEndDate', header: 'Seneste version til', type: 'date' },
        { key: 'versionCount', header: 'Antal versioner', type: 'number' },
        { key: 'latestVersionDescription', header: 'Beskrivelse', type: 'text', transform: (value: string) => value?.substring(0, 40) + (value?.length > 40 ? '...' : '') },
        {
          key: 'actions',
          header: '',
          type: 'button',
          buttonText: 'Rediger',
          buttonColor: 'primary',
          variant: 'raised',
          action: (row: any) => {
            functionRegistryService.executeFunction('openModal', 'edit_subtype', { data: row });
          }
        }
      ],
      pageable: true,
      sortable: true,
      rowHover: true,
      defaultSortColumn: 'name',
      defaultSortDirection: 'asc'
    }
  }
}
